export const InteractiveHelp = {

  init: () => {

  },

  /**
   * Show interactive help messenger
   * @param {string|undefined} predefinedMessage
   */
  show: (predefinedMessage = undefined) => {

  }
};
